
/**
 * 
 * @param {CanvasRenderingContext2D} ctx 
 */
function test(ctx) {
    ctx.fillStyle = "#fffff";
    ctx.fillRect(0, 0, 50, 50);
}
export const trim = (s) => {
    if (typeof s !== 'string') return '';
    return s.trim();
};

export const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const uppercase = (s) => {
    if (typeof s !== 'string') return '';
    return s.toUpperCase();
};

export const sneakPeek = (s, len) => {
    if (typeof s !== 'string') return '';
    if (s.length > len - 3) {
        return s.substring(0, len - 3) + "...";
    }
    return s;
}

export const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        let o = rv.find(e => e[0][key] == x[key]);
        if (o === undefined) {
            o = [];
            rv.push(o);
        }
        o.push(x);
        return rv;
    }, []);
};

export const mapBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        let k = x[key];
        if (!rv.hasOwnProperty(k)) {
            rv[k] = [];
        }
        rv[k].push(x);
        return rv;
    }, {});
};

export function extractParams(param, query, has) {
    let searchParams = new URLSearchParams(query);
    return has ? searchParams.has(param) : searchParams.get(param);
}